import { PEOPLE_IMAGE } from '../util/constants';

export const teamSections = [
    {
        teamName: 'Leadership Team',
        people: [
            {
                name: 'Jason Amri',
                title: '',
                position: 'Co-Executive Director',
                image: PEOPLE_IMAGE.jason_amri,
                link: '',
            },
            {
                name: 'Shub Atreya',
                title: '',
                position: 'Co-Executive Director',
                image: PEOPLE_IMAGE.shub_atreya,
                link: '',
            },
            {
                name: 'Gerry Chen',
                title: '',
                position: 'Head of Digital & Analytics',
                image: PEOPLE_IMAGE.gerry_chen,
                link: '',
            },
            {
                name: 'Chaewon Kang',
                title: '',
                position: 'Co-Head of Hack the Globe',
                image: PEOPLE_IMAGE.chaewon_kang,
                link: '',
            },
            {
                name: 'Amyna Ismail',
                title: '',
                position: 'Co-Head of Hack the Globe',
                image: PEOPLE_IMAGE.amyna_ismail,
                link: '',
            },
            {
                name: 'Audrey Gong',
                title: '',
                position: 'Head of Sponsorships & Partnerships',
                image: PEOPLE_IMAGE.audrey_gong,
                link: '',
            },
            {
                name: 'Evelyn Ritsaki',
                title: '',
                position: 'Head of Marketing & Design',
                image: PEOPLE_IMAGE.default,
                link: '',
            },
            {
                name: 'Vedant Iyer',
                title: '',
                position: 'Senior Curriculum Lead',
                image: PEOPLE_IMAGE.default,
                link: '',
            },
            {
                name: 'Katelyn Kuo',
                title: '',
                position: 'Head of People & Culture',
                image: PEOPLE_IMAGE.katelyn_kuo,
                link: '',
            },
        ],
    },
    {
        teamName: 'Digital & Analytics',
        people: [
            {
                name: 'Michael Wang',
                title: '',
                position: 'Software Engineering Manager',
                image: PEOPLE_IMAGE.michael_wang,
                link: '',
            },
            {
                name: 'Gregory Young',
                title: '',
                position: 'Software Engineering Manager',
                image: PEOPLE_IMAGE.gregory_young,
                link: '',
            },
            {
                name: 'Ryan Zhou',
                title: '',
                position: 'Software Engineering Manager',
                image: PEOPLE_IMAGE.ryan_zhou,
                link: '',
            },
            {
                name: 'Emmeline Handojo',
                title: '',
                position: 'Data Analytics Manager',
                image: PEOPLE_IMAGE.emmeline_handojo,
                link: '',
            },
            {
                name: 'Aania Raheem',
                title: '',
                position: 'Senior Data Analytics Lead',
                image: PEOPLE_IMAGE.aania_raheem,
                link: '',
            },
            {
                name: 'Stephanie Doan',
                title: '',
                position: 'Senior UX/UI Design Lead',
                image: PEOPLE_IMAGE.stephanie_doan,
                link: '',
            },
            {
                name: 'Rena Doan',
                title: '',
                position: 'Senior Software Engineer',
                image: PEOPLE_IMAGE.rena_doan,
                link: '',
            },
            {
                name: 'Alexander Yuyitung',
                title: '',
                position: 'Senior Software Engineer',
                image: PEOPLE_IMAGE.alexander_yuyitung,
                link: '',
            },
            {
                name: 'Elaine Lu',
                title: '',
                position: 'Software Engineer',
                image: PEOPLE_IMAGE.elaine_lu,
                link: '',
            },
            {
                name: 'Ivy Xu',
                title: '',
                position: 'Software Engineer',
                image: PEOPLE_IMAGE.ivy_xu,
                link: '',
            },
            {
                name: 'Naeem Hussain',
                title: '',
                position: 'Software Engineer',
                image: PEOPLE_IMAGE.naeem_hussain,
                link: '',
            },
            {
                name: 'Luna Nguyen',
                title: '',
                position: 'Software Engineer',
                image: PEOPLE_IMAGE.luna_nguyen,
                link: '',
            },
            {
                name: 'Riddhima Garg',
                title: '',
                position: 'Software Engineer',
                image: PEOPLE_IMAGE.riddhima_garg,
                link: '',
            },
            {
                name: 'Lahari Bonam',
                title: '',
                position: 'Software Engineer',
                image: PEOPLE_IMAGE.lahari_bonam,
                link: '',
            },
            {
                name: 'Calvin Weng',
                title: '',
                position: 'Software Engineer',
                image: PEOPLE_IMAGE.calvin_weng,
                link: '',
            },
            {
                name: 'Wahib Barqawi',
                title: '',
                position: 'Software Engineer',
                image: PEOPLE_IMAGE.wahib_barqawi,
                link: '',
            },
            {
                name: 'Beshoy Wassef',
                title: '',
                position: 'Software Engineer',
                image: PEOPLE_IMAGE.beshoy_wassef,
                link: '',
            },
            {
                name: 'Khai Lap Vuong',
                title: '',
                position: 'Data Analytics Lead',
                image: PEOPLE_IMAGE.khai_lap_vuong,
                link: '',
            },
            {
                name: 'Emma He',
                title: '',
                position: 'Data Analytics Lead',
                image: PEOPLE_IMAGE.emma_he,
                link: '',
            },
            {
                name: 'Prisha Tharwani',
                title: '',
                position: 'Data Analytics Lead',
                image: PEOPLE_IMAGE.prisha_tharwani,
                link: '',
            },
            {
                name: 'Bilal Khan',
                title: '',
                position: 'Data Analytics Lead',
                image: PEOPLE_IMAGE.default,
                link: '',
            },
        ],
    },
    {
        teamName: 'Hack the Globe',
        people: [
            {
                name: 'Dimitris Garofil',
                title: '',
                position: 'Managing Director',
                image: PEOPLE_IMAGE.dimitris_garofil,
                link: '',
            },
            {
                name: 'Belinda Zhao',
                title: '',
                position: 'Managing Director, Internal Strategy',
                image: PEOPLE_IMAGE.belinda_zhao,
                link: '',
            },
            {
                name: 'Shashwat Parikh',
                title: '',
                position: 'Managing Director, Internal Strategy',
                image: PEOPLE_IMAGE.shashwat_parikh,
                link: '',
            },
            {
                name: 'Heather Liu',
                title: '',
                position: 'Strategy & Operations Lead',
                image: PEOPLE_IMAGE.heather_liu,
                link: '',
            },
            {
                name: 'Leesha Pilla',
                title: '',
                position: 'Strategy & Operations Lead',
                image: PEOPLE_IMAGE.leesha_pilla,
                link: '',
            },
            {
                name: 'Tony Gao',
                title: '',
                position: 'Strategy & Operations Lead',
                image: PEOPLE_IMAGE.tony_gao,
                link: '',
            },
            {
                name: 'Arushi Chhikara',
                title: '',
                position: 'Strategy & Operations Lead',
                image: PEOPLE_IMAGE.arushi_chhikara,
                link: '',
            },
            {
                name: 'Hyeonji Jung',
                title: '',
                position: 'Strategy & Operations Lead',
                image: PEOPLE_IMAGE.hyeonji_jung,
                link: '',
            },
            {
                name: 'Jiangfeng Yu',
                title: '',
                position: 'Strategy & Operations Lead',
                image: PEOPLE_IMAGE.jiangfeng_yu,
                link: '',
            },
            {
                name: 'Kaining Wu',
                title: '',
                position: 'Strategy & Operations Lead',
                image: PEOPLE_IMAGE.kaining_wu,
                link: '',
            },
            {
                name: 'Nathannya Satyaviana',
                title: '',
                position: 'Strategy & Operations Lead',
                image: PEOPLE_IMAGE.default,
                link: '',
            },
            {
                name: 'Samaira Shah',
                title: '',
                position: 'Strategy & Operations Lead',
                image: PEOPLE_IMAGE.default,
                link: '',
            },
        ],
    },
    {
        teamName: 'Sponsors & Partnerships',
        people: [
            {
                name: 'Andrew Song',
                title: '',
                position: 'Managing Director',
                image: PEOPLE_IMAGE.andrew_song,
                link: '',
            },
            {
                name: 'Anmol Mahajan',
                title: '',
                position: 'Managing Director',
                image: PEOPLE_IMAGE.anmol_mahajan,
                link: '',
            },
            {
                name: 'Rukhsaar Tariq',
                title: '',
                position: 'Managing Director',
                image: PEOPLE_IMAGE.default,
                link: '',
            },
            {
                name: 'Georgie Burr',
                title: '',
                position: 'Senior Lead',
                image: PEOPLE_IMAGE.georgie_burr,
                link: '',
            },
            {
                name: 'Zoey Hou',
                title: '',
                position: 'Senior Lead',
                image: PEOPLE_IMAGE.zoey_hou,
                link: '',
            },
            {
                name: 'Malak Elsayed',
                title: '',
                position: 'Senior Lead',
                image: PEOPLE_IMAGE.malak_elsayed,
                link: '',
            },
            {
                name: 'Ethan Shewan',
                title: '',
                position: 'Senior Lead',
                image: PEOPLE_IMAGE.ethan_shewan,
                link: '',
            },
            {
                name: 'Kailey Cheng',
                title: '',
                position: 'Lead',
                image: PEOPLE_IMAGE.kailey_cheng,
                link: '',
            },
            {
                name: 'Evan Chan',
                title: '',
                position: 'Lead',
                image: PEOPLE_IMAGE.evan_chan,
                link: '',
            },
            {
                name: 'Yukttha Sivaraju',
                title: '',
                position: 'Lead',
                image: PEOPLE_IMAGE.yukttha_sivaraju,
                link: '',
            },
            {
                name: 'Shivatmika Sarin',
                title: '',
                position: 'Lead',
                image: PEOPLE_IMAGE.shivatmika_sarin,
                link: '',
            },
            {
                name: 'Zoe Salvador',
                title: '',
                position: 'Lead',
                image: PEOPLE_IMAGE.zoe_salvador,
                link: '',
            },
            {
                name: 'Veer Arora',
                title: '',
                position: 'Lead',
                image: PEOPLE_IMAGE.veer_arora,
                link: '',
            },
            {
                name: 'Lucas Yurcich',
                title: '',
                position: 'Lead',
                image: PEOPLE_IMAGE.lucas_yurcich,
                link: '',
            },
            {
                name: 'Nubia Tomita',
                title: '',
                position: 'Lead',
                image: PEOPLE_IMAGE.nubia_tomita,
                link: '',
            },
            {
                name: 'Nathan Stamenov',
                title: '',
                position: 'Lead',
                image: PEOPLE_IMAGE.nathan_stamenov,
                link: '',
            },
            {
                name: 'Suhani Mehta',
                title: '',
                position: 'Lead',
                image: PEOPLE_IMAGE.default,
                link: '',
            },
            {
                name: 'Alex Nguyen',
                title: '',
                position: 'Lead',
                image: PEOPLE_IMAGE.alex_nguyen,
                link: '',
            },
        ],
    },
    {
        teamName: 'Marketing & Design',
        people: [
            {
                name: 'Ishleen Wadehra',
                title: '',
                position: 'Managing Director',
                image: PEOPLE_IMAGE.ishleen_wadehra,
                link: '',
            },
            {
                name: 'Rishika Jain',
                title: '',
                position: 'Managing Director',
                image: PEOPLE_IMAGE.rishika_jain,
                link: '',
            },
            {
                name: 'Ally Yuen',
                title: '',
                position: 'Managing Director',
                image: PEOPLE_IMAGE.ally_yuen,
                link: '',
            },
            {
                name: 'Eleni Banta',
                title: '',
                position: 'Marketing Lead',
                image: PEOPLE_IMAGE.default,
                link: '',
            },
            {
                name: 'Kaavya Chaturvedi',
                title: '',
                position: 'Marketing Lead',
                image: PEOPLE_IMAGE.kaavya_chaturvedi,
                link: '',
            },
            {
                name: 'Michael Zou',
                title: '',
                position: 'Marketing Lead',
                image: PEOPLE_IMAGE.michael_zou,
                link: '',
            },
            {
                name: 'Devashi Gupta',
                title: '',
                position: 'Graphic Design Lead',
                image: PEOPLE_IMAGE.devashi_gupta,
                link: '',
            },
            {
                name: 'Ejae Kim',
                title: '',
                position: 'Graphic Design Lead',
                image: PEOPLE_IMAGE.ejae_kim,
                link: '',
            },
            {
                name: 'Ivana Duong',
                title: '',
                position: 'Graphic Design Lead',
                image: PEOPLE_IMAGE.ivana_duong,
                link: '',
            },
            {
                name: 'Rosanne Lee',
                title: '',
                position: 'Graphic Design Lead',
                image: PEOPLE_IMAGE.rosanne_lee,
                link: '',
            },
            {
                name: 'Claire Zhang',
                title: '',
                position: 'Graphic Design Lead',
                image: PEOPLE_IMAGE.claire_zhang,
                link: '',
            },
            {
                name: 'Mai Anh',
                title: '',
                position: 'Graphic Design Lead',
                image: PEOPLE_IMAGE.default,
                link: '',
            },
        ],
    },
    {
        teamName: 'People & Culture',
        people: [
            {
                name: 'Anna Zhong',
                title: '',
                position: 'Lead of Recruitment Managment',
                image: PEOPLE_IMAGE.anna_zhong,
                link: '',
            },
            {
                name: 'Matthew Su',
                title: '',
                position: 'Lead of Team Engagement',
                image: PEOPLE_IMAGE.matthew_su,
                link: '',
            },
            {
                name: 'Tony Liu',
                title: '',
                position: 'Lead of Team Engagement',
                image: PEOPLE_IMAGE.tony_liu,
                link: '',
            },
            {
                name: 'Kate Hsu',
                title: '',
                position: 'Lead of Team Engagement',
                image: PEOPLE_IMAGE.kate_hsu,
                link: '',
            },
            {
                name: 'Ana Hasan',
                title: '',
                position: 'Lead of Talent Development',
                image: PEOPLE_IMAGE.ana_hasan,
                link: '',
            },
            {
                name: 'Areeya Hanvichit',
                title: '',
                position: 'Lead of Recruitment Managment',
                image: PEOPLE_IMAGE.areeya_hanvi,
                link: '',
            },
            {
                name: 'Don Tsang',
                title: '',
                position: 'Lead of Talent Development',
                image: PEOPLE_IMAGE.don_tsang,
                link: '',
            },
            {
                name: 'Anna Erdos',
                title: '',
                position: 'Lead of Team Engagement',
                image: PEOPLE_IMAGE.anna_erdos,
                link: '',
            },
            {
                name: 'Richard Lui',
                title: '',
                position: 'Lead of Recruitment Managment',
                image: PEOPLE_IMAGE.richard_lui,
                link: '',
            },
            {
                name: 'Mahrosh Zafar',
                title: '',
                position: 'Senior Lead of Talent Development',
                image: PEOPLE_IMAGE.mahrosh_zafar,
                link: '',
            },
            {
                name: 'Krisha Dave',
                title: '',
                position: 'Lead of Recruitment Managment',
                image: PEOPLE_IMAGE.krisha_dave,
                link: '',
            },
            {
                name: 'Sampada Shah',
                title: '',
                position: 'Lead of Team Engagement',
                image: PEOPLE_IMAGE.sampada_shah,
                link: '',
            },
            {
                name: 'Vanessa Tsui',
                title: '',
                position: 'Lead of Team Engagement',
                image: PEOPLE_IMAGE.vanessa_tsui,
                link: '',
            },
        ],
    },
    {
        teamName: 'Board and Advisors',
        people: [
            {
                name: 'Malik Ismail (Chair)',
                title: 'Founder & Fmr. Exec. Director',
                position: 'Board Member',
                image: PEOPLE_IMAGE.malik_ismail,
                link: '',
            },
            {
                name: 'Julie Moysiuk',
                title: 'Fmr. Head of SICP, Speaker Panel',
                position: 'Board Member',
                image: PEOPLE_IMAGE.julie_moysiuk,
                link: '',
            },
            {
                name: 'Henry Zhang',
                title: 'Fmr. Head of Curriculum',
                position: 'Board Member',
                image: PEOPLE_IMAGE.henry_zhang,
                link: '',
            },
            {
                name: 'Dasha Pushkareva',
                title: 'Fmr. Head of Marketing & Digital',
                position: 'Board Member',
                image: PEOPLE_IMAGE.dasha_pushkareva,
                link: '',
            },
            {
                name: 'John Kim',
                title: 'Fmr. Head of Sponsorships & Partnerships',
                position: 'Board Member',
                image: PEOPLE_IMAGE.john_kim,
                link: '',
            },
            {
                name: 'Alyf Janmohamed',
                title: 'Fmr. Head of Speaker Panel',
                position: 'Board Member',
                image: PEOPLE_IMAGE.alyf_janmohamed,
                link: '',
            },
            {
                name: 'Hui Wen Zheng',
                title: 'Fmr. Co-executive Director',
                position: 'Board Member',
                image: PEOPLE_IMAGE.huiwen_zheng,
                link: '',
            },
            {
                name: 'Ben Mucsi',
                title: 'Fmr. Co-Executive Director',
                position: 'Board Member',
                image: PEOPLE_IMAGE.ben_mucsi,
                link: '',
            },
            {
                name: 'Kate Banting',
                title: 'Head of Social Impact & Marketing at BCG Canada',
                position: 'Advisor',
                image: PEOPLE_IMAGE.kate_banting,
                link: '',
            },
            {
                name: 'Christopher Yip',
                title: 'Dean of Engineering at UofT',
                position: 'Advisor',
                image: PEOPLE_IMAGE.christopher_yip,
                link: '',
            },
        ],
    },
];
